var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',{attrs:{"title":"order-statement.new.label","bread-crumb-data":_vm.breadCrumbData}},[_c('loading',{attrs:{"id":"order-select"}}),(_vm.statement)?_c('order-statement-form',{attrs:{"statement":_vm.statement}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }